module.exports = __webpack_public_path__ + "static/media/left-menu-playlist.c648d587.svg";